import { ITableRowViewModel } from '.';

export interface InLineControlRulesViewModel extends ITableRowViewModel {
  id: string;
  ruleName: string;
  ruleId: string;
  severity: string;
  detection: boolean;
  prevention: boolean;
  status: string;
}

export interface EdgeRulePolicy {
  active: boolean;
  action: EdgeRuleAction;
}
export interface EdgePolicy {
  id: string;
  zenityAccountId: string;
  policyName: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  rules?: Record<string, EdgeRule | RulePolicy>;
}

export interface EdgeRule extends Omit<DetectionRule, 'cvssScores'> {
  policyId?: string;
  accountId?: string;
}

export interface RulePolicy {
  active: boolean;
  action: EdgeRuleAction;
}

export interface DetectionRule extends RuleMetadata, RulePolicy, DetectionRuleContent {
  // All fields are inherited from base interfaces
}

// Unified rule metadata used in both detection and finding contexts
export interface RuleMetadata {
  id: string;
  name: string;
  title: string;
  status: string;
  description: string;
  severity: string;
  fixSuggestion: string;
  triageSuggestion: string;
  ruleVersion: string;
  summary: string;
  riskReason: string;
  references: string[];
  author?: string;
  createdAt?: string;
  modifiedAt?: string;
  updatedAt?: string;
  falsePositives: string[];
  riskLabels: string[];
  owasp: string[];
  genAiAttack: string[];
  tags: string[];
  cvssScores: CVSSScore[];
  targetSteps?: string[];
  platform: string;
}

export interface CVSSScore {
  score: string;
  vector: string;
  base: string;
}

// Detection-specific rule content (not relevant for findings)
export interface DetectionRuleContent {
  content: string; // SQL query, Sigma rule content, etc.
}

export enum EdgeRuleAction {
  BLOCK = 'block',
  DETECT = 'detect',
  MODIFY = 'modify',
}
